<template>
    <div class="flex flex-col">
        <!-- Header -->
        <div class="flex mb-4 space-x-4">
            <div
                v-for="page in pages"
                :key="`page-${page.id}`"
                @click="selectedPage = page"
                class="text-xl cursor-pointer"
                :class="{
                    'font-medium underline': page === selectedPage,
                }"
            >
                {{ page.title }}
            </div>
        </div>
        <!-- Content -->
        <component
            :is="`page-${selectedPage.slug}`"
            v-if="selectedPage"
            :selectedPage="selectedPage"
        ></component>
    </div>
</template>
<script>
export default {
    data() {
        return {
            pages: null,
            selectedPage: null,
        };
    },
    mounted() {
        const token = `Bearer ${window.token}`;
        axios.defaults.headers.common.Authorization = token;

        axios.get('/api/pages').then(({ data }) => {
            this.pages = data;
            const first = this.pages[0];
            this.selectedPage = first;
        });
    },
};
</script>
